import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 子材料列表
export const setSubMaterials: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.loading = !!payload.loading;
};

// 子材料详情
export const setSubMaterialDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 颜色信息
export const setSubMaterialColor: Mutation<IModuleState> = (state, payload) => {
  state.colors.data = payload.data;
  state.colors.loading = !!payload.loading;
};

export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.title = payload.title || state.confirm.title;
  state.confirm.content = payload.content || state.confirm.content;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
